export default __webpack_public_path__ + "img/dvCEXKMY.5d0cd6ca.svg";